/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import {
  TenkoDetailContext,
  TenkoKubunContext,
  UpsertTenkoDetailFunctionContext,
} from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLaugh, faTired } from "@fortawesome/free-solid-svg-icons"
import { siziZikoPage } from "../../../../constant/tablet/pages"
import { T点呼区分, e点呼区分 } from "../../../../constant/enum/unko"
import { AppDispatch } from "../../../.."
import { useDispatch } from "react-redux"
import { setAlerts } from "../../../../globalStore/alertStore"

const SelectHiroSippeiSuiminBusoku = () => {
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()

  const { 点呼区分 } = useContext(TenkoKubunContext)
  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)
  const upsertTenkoDetailFunction = useContext(UpsertTenkoDetailFunctionContext)

  const select体調 = (体調フラグ: 0 | 1) => async () => {
    switch (点呼区分?.区分コード as T点呼区分) {
      case e点呼区分.始業点呼:
      case e点呼区分.始業点呼2:
        set点呼明細({
          ...点呼明細,
          疲労疾病フラグ: 体調フラグ,
          睡眠不足フラグ: 体調フラグ,
        })
        history.push(siziZikoPage.Route.path)

        break
      // 中間はここで登録
      case e点呼区分.中間点呼１:
      case e点呼区分.中間点呼２:
      case e点呼区分.中間点呼３:
        try {
          const res = await upsertTenkoDetailFunction({
            疲労疾病フラグ: 体調フラグ,
            睡眠不足フラグ: 体調フラグ,
          })
          if (res == null) return
        } catch (error) {
          dispatch(setAlerts(error))
        }
        break
      default:
        break
    }
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>体調はいかがですか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={select体調(0)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem", color: "#0074be" }}
                    icon={faLaugh}
                  />
                  <span>問題なし</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={select体調(1)}>
                <table style={{ width: "100%", margin: "auto" }}>
                  <tr
                    style={{
                      width: "100%",
                      margin: "auto",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}>
                    <td className="d-inline-block h-100">
                      <FontAwesomeIcon
                        style={{
                          color: CSS_PROPERTY.WARN_COLOR,
                          margin: "auto",
                          marginRight: "2rem",
                        }}
                        icon={faTired}
                      />
                    </td>
                    <td className="d-inline-block">
                      <div>疲労疾病</div>
                      <div>睡眠不足</div>
                    </td>
                  </tr>
                </table>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectHiroSippeiSuiminBusoku
